import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import styles from "./homeStories.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import Link from "next/link";
import { getPopularAndRecent, likeStory } from "../../../api/requests";
import ErrorModal from "../../modals/ErrorModal";
import useTranslation from 'next-translate/useTranslation';

var Stories = function Stories(_ref) {
  var _stories$story, _stories$story2, _stories$story2$User, _stories$story3, _stories$story3$User;

  var homeData = _ref.homeData;

  // console.log("props: ",props);
  var _useState = useState("recent"),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = useState(null),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState({
    1: false,
    2: false,
    3: false
  }),
      pulse = _useState3[0],
      setPulse = _useState3[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var _useState4 = useState(null // {
  // story1: '',
  // story2: '',
  // story3: ''
  // }
  ),
      stories = _useState4[0],
      setStories = _useState4[1]; // console.log("stories",stories)


  useEffect(function () {
    getPopularAndRecentStories();
  }, []);

  var getPopularAndRecentStories = function getPopularAndRecentStories() {
    getPopularAndRecent().then(function (res) {
      console.log("pop res", res);
      setData(res.data);
    })["catch"](function (err) {
      return console.log("get popular and recent stories error: ", err);
    });
  }; // console.log("data",data)


  useEffect(function () {
    if (data && show === "popular") {
      setStories({
        story1: data.Populars[0],
        story2: data.Populars[1],
        story3: data.Populars[2]
      });
    }

    if (data && show === "recent") {
      setStories({
        story1: data.Recents[0],
        story2: data.Recents[1],
        story3: data.Recents[2]
      });
    }
  }, [show, data]);

  var numFormatter = function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  };

  var submitLike = function submitLike(StoryId) {
    var isLogin = localStorage.getItem('isLogin');
    var Username = localStorage.getItem('Username');

    if (isLogin && Username) {
      // console.log("do the like request", StoryId)
      likeStory(Counter, StoryId).then(function (res) {
        // console.log("like res: ", res)
        getPopularAndRecentStories();
      })["catch"](function (err) {
        return console.log("like error: ", err);
      });
    } else {
      setError(["login", false]);
      setShowErrorModal(true);
    }
  };

  var _useState5 = useState(null),
      error = _useState5[0],
      setError = _useState5[1];

  var _useState6 = useState(false),
      showErrorModal = _useState6[0],
      setShowErrorModal = _useState6[1];

  var toggle = function toggle() {
    return setShowErrorModal(!showErrorModal);
  };

  var getProfileImageSrc = function getProfileImageSrc(item) {
    var _item$User, _item$User2;

    if (item && (_item$User = item.User) !== null && _item$User !== void 0 && _item$User.ProfileImage && item.User.ProfileImage === 'img/head.png') {
      return '/images/table/profile.png';
    } else if (item && (_item$User2 = item.User) !== null && _item$User2 !== void 0 && _item$User2.ProfileImage && item.User.ProfileImage !== " ") {
      return item.User.ProfileImage;
    } else {
      return '/images/table/profile.png';
    }
  };

  var wordCount = function wordCount(str) {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");
    var count = str.split(' ').length;
    return count;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles.wrapper, " ").concat(isRTL ? styles.clipRight : ''),
    children: [/*#__PURE__*/_jsx(ErrorModal, {
      error: error,
      show: showErrorModal,
      toggle: toggle
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(Link, {
        href: {
          pathname: "/wow-stories"
        },
        children: /*#__PURE__*/_jsx("a", {
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.title,
            children: [/*#__PURE__*/_jsx("h2", {
              className: "".concat(styles.storiesTitle, " ").concat(isRTL ? styles.rtl : ''),
              style: {
                cursor: 'pointer'
              },
              children: t('home:wowStories')
            }), /*#__PURE__*/_jsx("h2", {
              className: styles.storyTitle,
              style: {
                cursor: 'pointer'
              },
              children: t('home:wowStories')
            })]
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.tab,
        children: [/*#__PURE__*/_jsx("div", {
          onClick: function onClick() {
            return setShow("recent");
          },
          className: "".concat(styles.tabItem, " ").concat(show === "recent" ? styles.active : ""),
          children: t('home:recentStories')
        }), /*#__PURE__*/_jsx("div", {
          onClick: function onClick() {
            return setShow("popular");
          },
          className: "".concat(styles.tabItem, " ").concat(show === "popular" ? styles.active : ""),
          children: t('home:popularStories')
        })]
      }), stories && stories.story1 && /*#__PURE__*/_jsxs("div", {
        className: styles.storyCardsWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.storyCard,
          children: [/*#__PURE__*/_jsx(Link, {
            href: {
              pathname: "/wow-stories/".concat(stories.story1.Id)
            },
            children: /*#__PURE__*/_jsxs("a", {
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.cardTitle,
                children: stories.story1["Title"]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.story,
                children: stories.story1["RewritedText"]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.footer,
            children: [/*#__PURE__*/_jsx(Link, {
              href: {
                pathname: "/profile/".concat(stories === null || stories === void 0 ? void 0 : (_stories$story = stories.story1) === null || _stories$story === void 0 ? void 0 : _stories$story.Counter),
                query: {
                  name: stories === null || stories === void 0 ? void 0 : (_stories$story2 = stories.story1) === null || _stories$story2 === void 0 ? void 0 : (_stories$story2$User = _stories$story2.User) === null || _stories$story2$User === void 0 ? void 0 : _stories$story2$User.FullName
                }
              },
              children: /*#__PURE__*/_jsx("a", {
                children: /*#__PURE__*/_jsx("img", {
                  className: styles.profileImage,
                  src: getProfileImageSrc(stories.story1),
                  alt: ""
                })
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.textWrapper,
              children: [/*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(stories.story1.Counter),
                  query: {
                    name: (_stories$story3 = stories.story1) === null || _stories$story3 === void 0 ? void 0 : (_stories$story3$User = _stories$story3.User) === null || _stories$story3$User === void 0 ? void 0 : _stories$story3$User.FullName
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  children: /*#__PURE__*/_jsx("p", {
                    className: styles.userName,
                    children: stories.story1.User.FullName
                  })
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.stats,
                children: [/*#__PURE__*/_jsxs("p", {
                  children: [t('home:score'), ": ", stories.story1.ReputationEffect ? numFormatter(Number(stories.story1.ReputationEffect)) : '-']
                }), /*#__PURE__*/_jsxs("p", {
                  children: [t('home:words'), ": ", stories.story1.RewritedText && wordCount(stories.story1.RewritedText)]
                }), /*#__PURE__*/_jsxs("p", {
                  className: "".concat(styles.likes, " "),
                  onClick: function onClick() {
                    return submitLike(stories.story1.StoryId);
                  },
                  onMouseDown: function onMouseDown() {
                    setPulse(function (prevState) {
                      return _objectSpread(_objectSpread({}, prevState), {}, {
                        1: true
                      });
                    });
                  },
                  onMouseUp: function onMouseUp() {
                    return setTimeout(function () {
                      setPulse(function (prevState) {
                        return _objectSpread(_objectSpread({}, prevState), {}, {
                          1: false
                        });
                      });
                    }, 1000);
                  },
                  children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: faHeart,
                    className: "".concat(isRTL ? [styles.likeIcon, styles.rtlIcon].join(' ') : styles.likeIcon, " ").concat(styles.blob, " ").concat(pulse[1] ? styles.pulse : '')
                  }), stories.story1["UpVotes"]]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.storyCard, " ").concat(styles.centerStoryCard),
          children: [/*#__PURE__*/_jsx(Link, {
            href: {
              pathname: "/wow-stories/".concat(stories.story2.Id)
            },
            children: /*#__PURE__*/_jsxs("a", {
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.cardTitle,
                children: stories.story2["Title"]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.story,
                children: stories.story2["RewritedText"]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.footer,
            children: [/*#__PURE__*/_jsx(Link, {
              href: {
                pathname: "/profile/".concat(stories.story2.Counter),
                query: {
                  name: stories.story2.User.FullName
                }
              },
              children: /*#__PURE__*/_jsx("a", {
                href: "",
                children: /*#__PURE__*/_jsx("img", {
                  className: styles.profileImage,
                  src: getProfileImageSrc(stories.story2)
                })
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.textWrapper,
              children: [/*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(stories.story2.Counter),
                  query: {
                    name: stories.story2.User.FullName
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  href: "",
                  children: /*#__PURE__*/_jsx("p", {
                    className: styles.userName,
                    children: stories.story2.User.FullName
                  })
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.stats,
                children: [/*#__PURE__*/_jsxs("p", {
                  children: [t('home:score'), ": ", stories.story2.ReputationEffect ? numFormatter(Number(stories.story2.ReputationEffect)) : '-']
                }), /*#__PURE__*/_jsxs("p", {
                  children: [t('home:words'), ": ", stories.story2.RewritedText && wordCount(stories.story2.RewritedText)]
                }), /*#__PURE__*/_jsxs("p", {
                  className: styles.likes,
                  onClick: function onClick() {
                    return submitLike(stories.story2.StoryId);
                  },
                  onMouseDown: function onMouseDown() {
                    setPulse(function (prevState) {
                      return _objectSpread(_objectSpread({}, prevState), {}, {
                        2: true
                      });
                    });
                  },
                  onMouseUp: function onMouseUp() {
                    return setTimeout(function () {
                      setPulse(function (prevState) {
                        return _objectSpread(_objectSpread({}, prevState), {}, {
                          2: false
                        });
                      });
                    }, 1000);
                  },
                  children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: faHeart,
                    className: "".concat(isRTL ? [styles.likeIcon, styles.rtlIcon].join(' ') : styles.likeIcon, " ").concat(styles.blob, " ").concat(pulse[2] ? styles.pulse : '')
                  }), stories.story2["UpVotes"]]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.storyCard, " ").concat(styles.thirdStoryCard),
          children: [/*#__PURE__*/_jsx(Link, {
            href: {
              pathname: "/wow-stories/".concat(stories.story3.Id)
            },
            children: /*#__PURE__*/_jsxs("a", {
              children: [/*#__PURE__*/_jsx("h4", {
                className: styles.cardTitle,
                children: stories.story3["Title"]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.story,
                children: stories.story3["RewritedText"]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.footer,
            children: [/*#__PURE__*/_jsx(Link, {
              href: {
                pathname: "/profile/".concat(stories.story3.Counter),
                query: {
                  name: stories.story3.User.FullName
                }
              },
              children: /*#__PURE__*/_jsx("a", {
                href: "",
                children: /*#__PURE__*/_jsx("img", {
                  className: styles.profileImage,
                  src: getProfileImageSrc(stories.story3),
                  alt: ""
                })
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.textWrapper,
              children: [/*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(stories.story3.Counter),
                  query: {
                    name: stories.story3.User.FullName
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  href: "",
                  children: /*#__PURE__*/_jsx("p", {
                    className: styles.userName,
                    children: stories.story3.User.FullName
                  })
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.stats,
                children: [/*#__PURE__*/_jsxs("p", {
                  children: [t('home:score'), ": ", stories.story3.ReputationEffect ? numFormatter(Number(stories.story3.ReputationEffect)) : '-']
                }), /*#__PURE__*/_jsxs("p", {
                  children: [t('home:words'), ": ", stories.story3.RewritedText && wordCount(stories.story3.RewritedText)]
                }), /*#__PURE__*/_jsxs("p", {
                  className: styles.likes,
                  onClick: function onClick() {
                    return submitLike(stories.story3.StoryId);
                  },
                  onMouseDown: function onMouseDown() {
                    setPulse(function (prevState) {
                      return _objectSpread(_objectSpread({}, prevState), {}, {
                        3: true
                      });
                    });
                  },
                  onMouseUp: function onMouseUp() {
                    return setTimeout(function () {
                      setPulse(function (prevState) {
                        return _objectSpread(_objectSpread({}, prevState), {}, {
                          3: false
                        });
                      });
                    }, 1000);
                  },
                  children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: faHeart,
                    className: "".concat(isRTL ? [styles.likeIcon, styles.rtlIcon].join(' ') : styles.likeIcon, " ").concat(styles.blob, " ").concat(pulse[3] ? styles.pulse : '')
                  }), stories.story3["UpVotes"]]
                })]
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("h4", {
        className: "".concat(styles.bottomHeader, " ").concat(styles.homeTitles),
        children: t('home:readStoriesInWow')
      })]
    })]
  });
};

export default Stories;